module.exports = __webpack_public_path__ + "static/media/ic_profile_general.89a8b84f.svg";